/** Shared client-side validation helpers for create/edit forms */

export const validators = {
  required:
    (label = 'This field') =>
    (value) => {
      if (value === null || value === undefined || String(value).trim() === '') {
        return `${label} is required`;
      }
      return null;
    },

  minLength:
    (min, label = 'This field') =>
    (value) => {
      if (value === null || value === undefined || value === '') return null;
      if (String(value).length < min) {
        return `${label} must be at least ${min} characters`;
      }
      return null;
    },

  number:
    (label = 'Value') =>
    (value) => {
      if (value === null || value === undefined || value === '') return null;
      if (Number.isNaN(Number(value))) return `${label} must be a valid number`;
      return null;
    },

  positiveNumber:
    (label = 'Value') =>
    (value) => {
      if (value === null || value === undefined || value === '') return null;
      const n = Number(value);
      if (Number.isNaN(n) || n < 0) return `${label} must be zero or greater`;
      return null;
    }
};

/**
 * @param {Record<string, Array<(value: unknown, values: object) => string|null>>} schema
 * @param {object} values
 * @returns {Record<string, string>}
 */
export function validateForm(schema, values) {
  const errors = {};

  Object.entries(schema).forEach(([field, fieldValidators]) => {
    const list = Array.isArray(fieldValidators) ? fieldValidators : [fieldValidators];
    for (const validator of list) {
      const message = validator(values[field], values);
      if (message) {
        errors[field] = message;
        break;
      }
    }
  });

  return errors;
}

export function hasFormErrors(errors) {
  return Object.values(errors).some(Boolean);
}
